import { useDispatch } from 'react-redux';
import { useMutation } from 'react-query';
import { wellnub } from 'network/wellnub.api';
import { setNutritionistSchedule } from 'features/nutritionists/state/nutritionist.slice';

export const queryFn = async payload => {
  const { serviceId, serviceModality, timeZone, nutritionistId } = payload;

  const url = `/v1/client/user/nutritionist/service/schedule/${nutritionistId}?serviceId=${serviceId}&serviceMode=${serviceModality}&timeZone=${timeZone}`;
  const { data } = await wellnub.get(url);

  return data;
};

export const useGetNutritionistScheduleService = () => {
  const dispatch = useDispatch();

  return useMutation('GET_NUTRITIONIST_APPOINTMENT_SCHEDULE', queryFn, {
    onSuccess: data => {
      dispatch(setNutritionistSchedule(data));
    },
  });
};
